import React from 'react';
import { Heart, Clock } from 'lucide-react';
import { notReady } from '../../data/mock';

const NotReadySection = () => {
  return (
    <section className="bg-black text-white py-20 lg:py-32">
      <div className="px-6 lg:px-12 xl:px-20">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 mb-8">
            <Heart className="w-10 h-10 text-accent-orange" />
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium leading-tight mb-6">
            {notReady.title}
          </h2>
          <p className="text-xl text-white/70 mb-10">{notReady.intro}</p>

          <div className="flex flex-wrap justify-center gap-4 mb-10">
            {notReady.points.map((point, index) => (
              <span
                key={index}
                className="px-6 py-3 bg-white/10 text-white font-medium"
              >
                {point}
              </span>
            ))}
          </div>

          <div className="p-8 bg-white/5 border border-white/10 inline-flex items-center gap-4 max-w-xl">
            <Clock className="w-6 h-6 text-white/50 flex-shrink-0" />
            <p className="text-white/70 text-left">
              {notReady.note}
            </p>
          </div>

          <p className="text-white/40 mt-10 italic">{notReady.footer}</p>
        </div>
      </div>
    </section>
  );
};

export default NotReadySection;
